<template>
    <div>
        <div id="reader"></div>
    </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode'
export default {
    name: 'QrcodeRender',

    data () {
        return {
            qrCodeScanner: null
        }
    },

    methods: {
        startScanner () {
            const qrCodeScanner = new Html5Qrcode('reader')
            qrCodeScanner.start(
                { facingMode: 'environment' },
                {
                    fps: 10,
                    qrbox: 250
                },
                (decodedText, decodedResult) => {
                    this.qrCodeScanner.stop()
                    return this.$emit('detect', decodedText)
                }
            ).catch((err) => {
                alert(`Unable to start QR code scanner: ${err}`)
            })

            this.qrCodeScanner = qrCodeScanner
        }
    },

    mounted () {
        this.startScanner()
    },

    beforeDestroy () {
        if (this.qrCodeScanner) {
            this.qrCodeScanner.stop().catch((err) => {
                alert(`Unable to stop QR code scanner: ${err}`)
            })
        }
    }
}
</script>

<style>
</style>
